import { createFileRoute } from "@tanstack/react-router";
import { CallTypesScreen } from "../components/relations/CallTypesScreen";

export const Route = createFileRoute("/_auth/relations/scripts")({
  staticData: {
    titleKey: "relations.scripts.title",
    breadcrumbKey: "breadcrumb.operate",
    breadcrumbN: 7,
  },
  component: CallTypesScreen,
});
